<script>
  import QRCode from 'qrcode';
	
	export let codeValue;
  export let squareSize; 
  const padding = 10;
  
  function createQrCode(data, width) {
    let canvas = document.getElementById('canvas');
    if (canvas && data) {
      QRCode.toCanvas(canvas, data, {'width': width, 'margin': 0}, function (error) {
        if (error) console.error(error)
//        console.log('success!');
      })
    }
  }

  $: qrSize = squareSize - 2 * padding
  $: createQrCode(codeValue, qrSize);
			
</script>

<div style="padding:{padding}px">
  <canvas id="canvas"/>
</div>

